// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyramais-account-card {
  min-height: 6.875rem;
}
.gyramais-account-card.editable-card {
  animation: warning 1.5s infinite;
}
.gyramais-account-card.bank-account {
  cursor: pointer;
}
.gyramais-account-card .logo {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.gyramais-account-card .logo .logo-wrapper {
  max-height: 2.625rem;
  max-width: 9.688rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
@media (max-width: 768px) {
  .gyramais-account-card .logo .logo-wrapper {
    max-width: none;
  }
}
.gyramais-account-card .logo .card-logo {
  width: 100%;
  height: 100%;
  max-height: 2.625rem;
}
@media (max-width: 768px) {
  .gyramais-account-card .logo .card-logo {
    width: auto;
    height: 2.625rem;
  }
}
@media (max-width: 35rem) {
  .gyramais-account-card .logo .card-logo {
    height: 1.625rem;
  }
}
.gyramais-account-card .logo .gyramais-status {
  margin-left: 1rem;
}
.gyramais-account-card .actions-wrapper {
  width: 100%;
}
.gyramais-account-card .checkbox-container {
  margin-right: 0.6rem;
}
.gyramais-account-card .checkbox-container .ant-checkbox-inner {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50% !important;
}
@media (max-width: 768px) {
  .gyramais-account-card .checkbox-container {
    justify-content: center;
  }
}
.gyramais-account-card.selected-account-card {
  border: 0.188rem solid var(--primary-button-color);
}
.gyramais-account-card .logo {
  text-align: left;
}
.gyramais-account-card .account-card-content {
  transition: 0.2s;
}
.gyramais-account-card .account-card-content.on-loading {
  filter: blur(0.3rem);
}
.gyramais-account-card .upload-card-icon {
  color: var(--link-button-color);
  font-size: 1.6rem;
  cursor: pointer;
}
.gyramais-account-card .approved-analysis-icon {
  color: var(--success-color);
  font-size: 1.8rem;
  cursor: pointer;
}
.gyramais-account-card .buttons-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.gyramais-account-card .buttons-col .gyramais-btn {
  margin-left: 1rem;
}
@media (max-width: 768px) {
  .gyramais-account-card .buttons-col {
    width: 100%;
    justify-content: space-between;
    padding-top: 1rem;
  }
  .gyramais-account-card .buttons-col .gyramais-btn {
    margin-left: 0;
  }
  .gyramais-account-card .buttons-col .gyramais-btn-link {
    width: 2rem;
  }
}
.gyramais-account-card .card-loading-container {
  transition: 0.2s;
  z-index: -1;
  opacity: 0;
  position: absolute;
  border-radius: 0.313rem;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000010;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 6rem;
}
.gyramais-account-card .card-loading-container.on-loading {
  opacity: 1;
  z-index: 10;
}
@media (max-width: 768px) {
  .gyramais-account-card .card-loading-container {
    padding: 0 1rem;
  }
}
.gyramais-account-card .re-integrate {
  white-space: nowrap;
}
.gyramais-account-card .status-name {
  white-space: nowrap;
}
.gyramais-account-card + .gyramais-account-card {
  margin-top: 1rem !important;
}
#integration-remove-modal {
  display: flex;
  flex-direction: column;
  padding: 1.5rem 2.8rem;
  align-items: center;
  text-align: center;
}
#integration-remove-modal .svg-image {
  width: 100%;
  height: auto;
}
#integration-remove-modal .svg-image svg {
  width: 100%;
}
#integration-remove-modal .btn-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}
#integration-remove-modal .btn-group button:first-child {
  padding: 0.5rem 2rem;
}
@media (max-width: 768px) {
  #integration-remove-modal .btn-group {
    flex-direction: column-reverse;
    width: 100%;
  }
}
.mobile-style {
  padding: 1.5rem 2rem !important;
}
.mobile-style .logo-wrapper {
  max-width: none;
}
.mobile-style .card-logo {
  width: auto;
  height: 2.625rem;
}
.mobile-style .checkbox-container {
  justify-content: center;
}
.mobile-style .card-loading-container {
  padding: 0 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/gyramais/AccountCard/styles.less"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AACE;EACE,gCAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AARA;EAYI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AADJ;AAdA;EAkBM,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AADN;AAGM;EAAA;IACE,eAAA;EAAN;AACF;AA1BA;EA8BM,WAAA;EACA,YAAA;EACA,oBAAA;AADN;AAGM;EAAA;IACE,WAAA;IACA,gBAAA;EAAN;AACF;AAEM;EAAA;IACE,gBAAA;EACN;AACF;AA1CA;EA6CM,iBAAA;AAAN;AA7CA;EAkDI,WAAA;AAFJ;AAhDA;EAsDI,oBAAA;AAHJ;AAnDA;EAyDM,cAAA;EACA,eAAA;EAEA,6BAAA;AAJN;AAOI;EAAA;IACE,uBAAA;EAJJ;AACF;AAOE;EACE,kDAAA;AALJ;AAhEA;EAyEI,gBAAA;AANJ;AAnEA;EA6EI,gBAAA;AAPJ;AASI;EACE,oBAAA;AAPN;AAzEA;EAqFI,+BAAA;EACA,iBAAA;EACA,eAAA;AATJ;AA9EA;EA2FI,2BAAA;EACA,iBAAA;EACA,eAAA;AAVJ;AAnFA;EAiGI,aAAA;EACA,mBAAA;EACA,yBAAA;AAXJ;AAxFA;EAsGM,iBAAA;AAXN;AAcI;EAAA;IACE,WAAA;IACA,8BAAA;IACA,iBAAA;EAXJ;EAQE;IAMI,cAAA;EAXN;EAKE;IAUI,WAAA;EAZN;AACF;AAxGA;EAyHI,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;AAdJ;AAgBI;EACE,UAAA;EACA,WAAA;AAdN;AAiBI;EAAA;IACE,eAAA;EAdJ;AACF;AAlIA;EAoJI,mBAAA;AAfJ;AArIA;EAwJI,mBAAA;AAhBJ;AAxIA;EA4JI,2BAAA;AAjBJ;AAqBA;EAUE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AA5BF;AAcA;EAEI,WAAA;EACA,YAAA;AAbJ;AAUA;EAMM,WAAA;AAbN;AAOA;EAuBI,aAAA;EACA,yBAAA;EACA,gBAAA;AA3BJ;AAoBM;EACE,oBAAA;AAlBR;AA0BI;EAAA;IACE,8BAAA;IACA,WAAA;EAvBJ;AACF;AA2BA;EACE,+BAAA;AAzBF;AAwBA;EAII,eAAA;AAzBJ;AAqBA;EAQI,WAAA;EACA,gBAAA;AA1BJ;AAiBA;EAaI,uBAAA;AA3BJ;AAcA;EAiBI,eAAA;AA5BJ","sourcesContent":[".gyramais-account-card {\n  min-height: 6.875rem;\n\n  &.editable-card {\n    animation: warning 1.5s infinite;\n  }\n\n  &.bank-account {\n    cursor: pointer;\n  }\n\n  .logo {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    .logo-wrapper {\n      max-height: 2.625rem;\n      max-width: 9.688rem;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n\n      @media (max-width: @md-screen) {\n        max-width: none;\n      }\n    }\n\n    .card-logo {\n      width: 100%;\n      height: 100%;\n      max-height: 2.625rem;\n\n      @media (max-width: @md-screen) {\n        width: auto;\n        height: 2.625rem;\n      }\n\n      @media (max-width: 35rem) {\n        height: 1.625rem;\n      }\n    }\n\n    .gyramais-status {\n      margin-left: 1rem;\n    }\n  }\n\n  .actions-wrapper {\n    width: 100%;\n  }\n\n  .checkbox-container {\n    margin-right: 0.6rem;\n\n    .ant-checkbox-inner {\n      width: 1.25rem;\n      height: 1.25rem;\n\n      border-radius: 50% !important;\n    }\n\n    @media (max-width: @md-screen) {\n      justify-content: center;\n    }\n  }\n\n  &.selected-account-card {\n    border: 0.188rem solid var(--primary-button-color);\n  }\n\n  .logo {\n    text-align: left;\n  }\n\n  .account-card-content {\n    transition: 0.2s;\n\n    &.on-loading {\n      filter: blur(0.3rem);\n    }\n  }\n\n  .upload-card-icon {\n    color: var(--link-button-color);\n    font-size: 1.6rem;\n    cursor: pointer;\n  }\n\n  .approved-analysis-icon {\n    color: var(--success-color);\n    font-size: 1.8rem;\n    cursor: pointer;\n  }\n\n  .buttons-col {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    .gyramais-btn {\n      margin-left: 1rem;\n    }\n\n    @media (max-width: @md-screen) {\n      width: 100%;\n      justify-content: space-between;\n      padding-top: 1rem;\n\n      .gyramais-btn {\n        margin-left: 0;\n      }\n\n      .gyramais-btn-link {\n        width: 2rem;\n      }\n    }\n  }\n\n  .card-loading-container {\n    transition: 0.2s;\n    z-index: -1;\n    opacity: 0;\n    position: absolute;\n    border-radius: 0.313rem;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #00000010;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding: 0 6rem;\n\n    &.on-loading {\n      opacity: 1;\n      z-index: 10;\n    }\n\n    @media (max-width: @md-screen) {\n      padding: 0 1rem;\n    }\n  }\n\n  .re-integrate {\n    white-space: nowrap;\n  }\n\n  .status-name {\n    white-space: nowrap;\n  }\n\n  + .gyramais-account-card {\n    margin-top: 1rem !important;\n  }\n}\n\n#integration-remove-modal {\n  .svg-image {\n    width: 100%;\n    height: auto;\n\n    svg {\n      width: 100%;\n    }\n  }\n\n  display: flex;\n  flex-direction: column;\n  padding: 1.5rem 2.8rem;\n  align-items: center;\n  text-align: center;\n\n  .btn-group {\n    button {\n      &:first-child {\n        padding: 0.5rem 2rem;\n      }\n    }\n\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 2rem;\n\n    @media (max-width: @md-screen) {\n      flex-direction: column-reverse;\n      width: 100%;\n    }\n  }\n}\n\n.mobile-style {\n  padding: 1.5rem 2rem !important;\n\n  .logo-wrapper {\n    max-width: none;\n  }\n\n  .card-logo {\n    width: auto;\n    height: 2.625rem;\n  }\n\n  .checkbox-container {\n    justify-content: center;\n  }\n\n  .card-loading-container {\n    padding: 0 1rem;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
